import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import Sidebar from "../../layout/Sidebar";
import Navbar from "../../layout/Navbar";
import ReactToPrint from "react-to-print";

import moment from "moment";
import { getAllAccount } from "../../../actions/accountsAction";
import { getAlljournalvoucheritemsByAccount } from "../../../actions/accounting/JournalVoucheritems";
import { getAllreceivevoucheritemsByAccount } from "../../../actions/accounting/ReceiveVoucheritems";
import { getAllpaymentvoucheritemByAccount } from "../../../actions/accounting/paymentVoucheritems";
import { getAllInvoicesByAccount } from "../../../actions/invoiceItem";
import { getAllPayslipByAccount } from "../../../actions/PaySlipAction";
import { getCashBankLedger } from "../../../actions/journalAction";
import { getAllLocation } from "../../../actions/warehouseAction";

import {
  Layout,
  Breadcrumb,
  Row,
  Col,
  DatePicker,
  Space,
  Select,
  Divider,
  Skeleton,
  Button,
  Spin,
} from "antd";
const { Content } = Layout;
const { RangePicker } = DatePicker;
const { Option } = Select;

const CashAndBankLedger = ({
  getCashBankLedger,
  getAllAccount,
  getAlljournalvoucheritemsByAccount,
  getAllreceivevoucheritemsByAccount,
  getAllpaymentvoucheritemByAccount,
  getAllInvoicesByAccount,
  getAllPayslipByAccount,
  businessprofile,
  getAllLocation,
}) => {
  const componentRef = useRef();
  const [accounts, setAccounts] = useState([]);
  const accountNo = useRef();
  const [journalsVoucher, setJournalsVoucher] = useState([]);
  const [receiveVoucher, setReceiveVoucher] = useState([]);
  const [paymentVoucher, setPaymentVoucher] = useState([]);
  const [journals, setJournals] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [payslips, setPayslips] = useState([]);
  const [type, setType] = useState("date");
  const [loading, setloading] = useState(true);
  const [reload, setreload] = useState(true);
  const [dataFetched, setDateFetched] = useState(false);
  const openingDate = useRef("");
  const start = useRef("");
  const end = useRef("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [locations, setLocations] = useState([]);
  const locationId = useRef("");

  const totaldebit = useRef(0);
  const totalcredit = useRef(0);
  const endingBalance = useRef(0);
  const currentBalance = useRef(0);

  const openingcredit = useRef(0);
  const openingdebit = useRef(0);
  const openingbalance = useRef(0);

  useEffect(() => {
    getAllAccount().then((result) => {
      let account = [];
      for (let i = 0; i < result.length; i++) {
        account.push(result[i]);
      }
      setAccounts(account);
      setDateFetched(true);
    });
    getAllLocation().then((result) => {
      setLocations(result);
    });
  }, []);

  useEffect(() => {
    setloading(true);
    if (
      accountNo.current > 0 &&
      openingDate.current != "" &&
      end.current != ""
    ) {
      getCashBankLedger(
        openingDate.current,
        start.current,
        end.current,
        accountNo.current,
        locationId.current
      ).then((result) => {
        let res = [];
        
        openingdebit.current = result.opening_debit;
        openingcredit.current = result.opening_credit;
        openingbalance.current = result.opening_balance;
        
        totaldebit.current = result.opening_debit;
        totalcredit.current = result.opening_credit;
        
        let runningBalance = parseFloat(openingbalance.current || 0);
        currentBalance.current = runningBalance;

        let journalsList = result.journals || [];
        let reversedList = [...journalsList].reverse();
        
        for (let i = 0; i < reversedList.length; i++) {
          let journal = { ...reversedList[i] };
          if (journal.type == "Debit") {
            totaldebit.current += parseFloat(journal.amount);
            runningBalance += parseFloat(journal.amount);
          } else {
            totalcredit.current += parseFloat(journal.amount);
            runningBalance -= parseFloat(journal.amount);
          }
          journal.balance = runningBalance;
          res.push(journal);
        }
        setJournals(res);
        endingBalance.current = totaldebit.current - totalcredit.current;
        setloading(false);
      });
    }
  }, [reload]);

  const SwitchablePicker = () => {
    return (
      <Row gutter={[16, 16]}>
        <Col flex="auto">
          Date:
          <RangePicker
            picker={type}
            style={{ width: "100%" }}
            onChange={(value) => {
              if (value) {
                if (value[0].format("MM") > 6) {
                  openingDate.current =
                    value[0].format("YYYY") + "-07-01T00:00:00";
                } else {
                  openingDate.current =
                    value[0].format("YYYY") - 1 + "-07-01T00:00:00";
                }
                start.current = value[0].format("YYYY-MM-DD") + "T00:00:00";
                end.current = value[1].format("YYYY-MM-DD") + "T23:59:59";
                setStartTime(value[0].format("YYYY-MM-DD") + "T00:00:00");
                setEndTime(value[1].format("YYYY-MM-DD") + "T23:59:59");
              }
            }}
          />
        </Col>
        <Col flex="auto">
          Account:
          {dataFetched ? (
            <Select
              placeholder="select a Account"
              style={{ width: "100%" }}
              onChange={(e) => {
                accountNo.current = e;
              }}
            >
              {accounts.map((account) => {
                return <Option key={account.id} value={account.id}>{account.name}</Option>;
              })}
            </Select>
          ) : (
            <p>Loading...</p>
          )}
        </Col>
        <Col flex="auto">
          Location:
          <Select
            placeholder="Select Location"
            style={{ width: "100%" }}
            onChange={(e) => {
              locationId.current = e || "";
            }}
            allowClear
          >
            {locations.map((loc) => (
              <Option key={loc.id} value={loc.id}>{loc.name}</Option>
            ))}
          </Select>
        </Col>
        <Col flex="none">
          <br />
          <Button type="primary" onClick={() => setreload(!reload)}>
            Search
          </Button>
        </Col>
        <Col flex="none">
          <br />
          <ReactToPrint
            trigger={() => (
              <Button type="primary" style={{ width: "100%" }}>
                Print Ledger
              </Button>
            )}
            content={() => componentRef.current}
          />
        </Col>
      </Row>
    );
  };

  const Rendercontent = () => {
    return (
      <>
        <Row>
          <Col
            span={24}
            style={{ padding: "1rem", border: "1px solid whitesmoke" }}
          >
            {SwitchablePicker()}
            <Divider />
            {accountNo.current > 0 &&
              openingDate.current != "" &&
              end.current != "" ? (
              <Spin spinning={loading}>
                <div ref={componentRef} style={{ padding: "20px" }}>
                  <table className="history_table">
                    <tr>
                      <td>Date</td>
                      <td>Particular</td>
                      <td>Narration</td>
                      <td>Cash In</td>
                      <td>Cash Out</td>
                      <td>Amount</td>
                    </tr>

                    <tr>
                      <td>-</td>
                      <td>-</td>
                      <td>
                        <b>Opening Balance</b>
                      </td>
                      <td>-</td>
                      <td>-</td>
                      <td>
                        <b>{openingbalance.current}</b>
                      </td>
                    </tr>

                    {journals.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            {moment(item.created).format("DD-MM-YYYY")}
                          </td>
                          <td>{item.Subgroup}</td>
                          <td>{item.details}</td>
                          <td>
                            {item.type == "Credit" ? "" : item.amount}
                          </td>
                          <td>
                            {item.type == "Credit" ? item.amount : ""}
                          </td>
                          <td>{item.balance}</td>
                        </tr>
                      );
                    })}

                    <tr>
                      <td colSpan={3}>
                        <b>Total</b>
                      </td>
                      <td>
                        <b>{totaldebit.current - openingdebit.current}</b>
                      </td>
                      <td>
                        <b>{totalcredit.current - openingcredit.current}</b>
                      </td>
                      <td>
                        <b>
                          {endingBalance.current < 0
                            ? "(" + endingBalance.current * -1 + ")"
                            : endingBalance.current}
                        </b>
                      </td>
                    </tr>
                  </table>
                  <Row style={{ minHeight: "60px", marginTop: "40px" }}>
                    <Col span={12} style={{ textAlign: "left" }}>
                      {/* <img
                        src={businessprofile.signature}
                        style={{
                          maxHeight: "60px",
                          left: "0",
                        }}
                      /> */}
                    </Col>
                    <Col span={12} style={{ textAlign: "center" }}></Col>
                  </Row>
                  <Row>
                    <Col span={12} style={{ textAlign: "left" }}>
                      <h3
                        style={{
                          borderTop: "2px solid black",
                          display: "inline-block",
                        }}
                      >
                        ACCOUNT SIGNATURE
                      </h3>
                    </Col>
                    <Col span={12} style={{ textAlign: "right" }}>
                      <h3
                        style={{
                          borderTop: "2px solid black",
                          display: "inline-block",
                        }}
                      >
                        AUTHORIZER SIGNATURE
                      </h3>
                    </Col>
                  </Row>
                </div>
              </Spin>
            ) : (
              "Please select an account and date"
            )}
          </Col>
        </Row>
      </>
    );
  };

  return (
    <>
      <Layout className="window-frame">
        <Sidebar />
        <Layout className="site-layout">
          <Navbar />
          <Content className="main-frame-content">
            <Breadcrumb style={{ margin: "16px 0" }}>
              <Breadcrumb.Item>Cash & Bank Ledger</Breadcrumb.Item>
            </Breadcrumb>
            <div className="site-layout-background main-frame">
              {Rendercontent()}
            </div>
          </Content>
        </Layout>
      </Layout>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    businessprofile: state.settings.businessprofile,
  };
};

export default connect(mapStateToProps, {
  getCashBankLedger,
  getAllAccount,
  getAlljournalvoucheritemsByAccount,
  getAllreceivevoucheritemsByAccount,
  getAllpaymentvoucheritemByAccount,
  getAllInvoicesByAccount,
  getAllPayslipByAccount,
  getAllLocation,
})(CashAndBankLedger);
